import {useCommunitiesFeatures} from './useCommunitiesFeatures';

export const useSomeCommunityHasFeature = (
  communityIds: string[],
  featureName: string,
) => {
  const communitiesFeaturesResponse = useCommunitiesFeatures();

  return {
    ...communitiesFeaturesResponse,
    hasFeature: communitiesFeaturesResponse.data
      ?.filter(community => communityIds.includes(community.communityId))
      .some(community => community.features.includes(featureName)),
  };
};
